import React from 'react';
import { t } from '@web-solutions/module-localization';

import styles from './style.module.scss';
import tashaImg from '../../../../assets/images/tashaWithoutFace.png';
import isabellaImg from '../../../../assets/images/IsabellaWithotFace.png';
import MichaelImg from '../../../../assets/images/michael.webp';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';

const Reviews = () => {
  const customers = [
    {
      img: tashaImg,
      name: t('onboarding.glpReviews.customers.1.name'),
      weightBefore: '165 lbs',
      weightAfter: '132 lbs',
    },
    {
      img: MichaelImg,
      name: t('onboarding.glpReviews.customers.2.name'),
      weightBefore: '264 lbs',
      weightAfter: '202 lbs',
    },
    {
      img: isabellaImg,
      name: t('onboarding.glpReviews.customers.3.name'),
      weightBefore: '198 lbs',
      weightAfter: '121 lbs',
    },
  ];

  return (
    <div className={styles.reviews}>
      {customers.map(({ img, name, weightAfter, weightBefore }) => (
        <div className={styles.review} key={name}>
          <div className={styles.reviewImgContainer}>
            <img className={styles.reviewImg} src={img} alt='customer' />

            <div className={styles.stateBefore}>
              <Caption size='l'>{weightBefore}</Caption>
            </div>
            <div className={styles.stateAfter}>
              <Caption size='l'>{weightAfter}</Caption>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Reviews;
